import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import * as types from '../../../constants/types'
import styles from './button.module.scss'

export const BUTTON_HTML_TYPES = ['button', 'submit']

const Button = (props) => {
  const {
    id,
    children,
    className,
    disabled,
    full,
    margin,
    onClick,
    type,
    buttonType,
    width,
    height
  } = props

  const buttonClass = classNames(styles.button, className, {
    [styles[type]]: type,
    [styles.full]: full,
    [styles.disabled]: disabled
  })

  const buttonStyle = {}

  if (margin) buttonStyle.margin = margin
  if (width) buttonStyle.width = width
  if (height) buttonStyle.height = height

  const handleClick = (event) => {
    if (disabled) {
      event.preventDefault()
      event.stopPropagation()

      return
    }

    if (onClick) {
      onClick()
    }
  }

  return (
    <button
      id={id}
      className={buttonClass}
      style={buttonStyle}
      // eslint-disable-next-line react/button-has-type
      type={buttonType}
      onClick={handleClick}
    >
      {children}
    </button>
  )
}

Button.defaultProps = {
  id: undefined,
  children: null,
  type: null,
  buttonType: 'button',
  margin: null,
  full: false,
  disabled: false,
  onClick: null,
  className: null,
  width: null,
  height: null
}

Button.propTypes = {
  id: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  type: PropTypes.oneOf(types.BUTTON_TYPES),
  buttonType: PropTypes.oneOf(BUTTON_HTML_TYPES),
  margin: PropTypes.string,
  full: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}

export default Button
